// extracted by mini-css-extract-plugin
export default {"menuTableCard":"wqVM89Yb_QPvE6fKu4BI","left":"pgv1DtkRdJrcZWi5BVeN","center":"DVLt8ZtmWh07QtqqTGga","right":"dHWCGab60xWtIvyfnqkE"};